// extracted by mini-css-extract-plugin
export default {"filterSection":"filter_filterSection__VviAa","filterGroup":"filter_filterGroup__la8gB"};